import React from 'react';

import FormDialog from 'scenes/Dialog/components/FormDialog';
import BasicDialog from 'scenes/Dialog/components/BasicDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import SendMessageForm from 'scenes/Form/components/SendMessageForm';

import { ENDPOINT } from 'constants/endpoints';
import { POPUP_STYLES } from 'constants/popup-styles';
import { useApi } from 'hooks/useApi';

const withNetworkActions = WrappedComponent => props => {
  const api = useApi();

  const sendMessageForm = (title, recipients) => {
    FormDialog({
      title,
      modeless: false,
      compact: true,
      popupStyles: { padding: '0', maxWidth: '800px' },
      popupInnerStyles: { padding: '0 30px' },
      params: { recipients },
      form: (actions, params) => (
        <SendMessageForm actions={actions} params={params} />
      ),
    }).then(
      message =>
        BasicDialog({
          bodyRender: message,
          bodyStyles: POPUP_STYLES.warningBodyStyles,
          popupStyles: POPUP_STYLES.warningPopupStyles,
          popupInnerStyles: POPUP_STYLES.warningContentStyles,
          withoutButtons: true,
        }),
      response => ResponseErrorDialog({ response })
    );
  };

  const getResponseHandlers = (resolve, reject) => ({
    handleError: response => {
      ResponseErrorDialog({ response });
      reject();
    },
    handleSuccess: response => resolve(response),
  });

  const connect = ({ id }) =>
    new Promise((resolve, reject) =>
      api.post(
        ENDPOINT.ACTION.NETWORK.CONNECT,
        { id },
        getResponseHandlers(resolve, reject)
      )
    );

  const reject = ({ token }) =>
    new Promise((resolve, reject) =>
      api.post(
        ENDPOINT.ACTION.NETWORK.REJECT,
        { token },
        getResponseHandlers(resolve, reject)
      )
    );

  const accept = ({ token }) =>
    new Promise((resolve, reject) =>
      api.post(
        ENDPOINT.ACTION.NETWORK.ACCEPT,
        { token },
        getResponseHandlers(resolve, reject)
      )
    );

  const message = (recipients, to = null) => {
    if (recipients) {
      sendMessageForm(`Message to ${to}`, recipients);
    }
  };

  const messageSelected = recipients => {
    let warning = null;
    if (!recipients.length) {
      warning = 'Please select at least one candidate';
    }

    if (warning) {
      BasicDialog({
        bodyRender: warning,
        bodyStyles: {
          fontSize: '1.286rem',
          fontWeight: '500',
          maxWidth: '380px',
        },
        popupStyles: {
          padding: '50px 30px',
        },
        popupInnerStyles: {
          marginTop: '40px',
        },
        withoutButtons: true,
      });
    } else {
      sendMessageForm('Email All Selected Candidates', recipients);
    }
  };

  return (
    <WrappedComponent
      networkAction={{
        connect,
        accept,
        reject,
        message,
        messageSelected,
      }}
      {...props}
    />
  );
};

export default withNetworkActions;
